import React, { useEffect } from 'react'
import { useConfirm, confirmDelete, confirmLogout } from '../../../components/ConfirmDialog';
import Table, { AvatarCell } from './../../../components/Table'
import { connect } from 'react-redux'
import { TrashIcon, PlusCircleIcon, UserGroupIcon, UserAddIcon } from '@heroicons/react/outline';
import Modal from '../../../components/Modal';
import {
    getGuestsRequested,
    addGuestRequested,
    updateGuestRequested,
    deleteGuestRequested
} from '../../../actions/guestAction';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { useNavigate, useOutletContext } from 'react-router-dom';

const Guests = ({
    guests,
    user,
    guestsGetRequested,
    getGuestsRequested: getGuests,
    addGuestRequested: addGuest,
    updateGuestRequested: updateGuest,
    deleteGuestRequested: deleteGuest,
}) => {
    const confirm = useConfirm();
    const [showModal, setShowModal] = React.useState(false);
    const [edit, setEdit] = React.useState(false);
    const [formData, setFormData] = React.useState({});
    const { activeCell } = useOutletContext() || {};
    const id = activeCell?.id;
    const navigate = useNavigate();

    // Refetch whenever the selected cell changes.
    useEffect(() => {
        if (id) {
            getGuests(id)
        }
    }, [id]);

    const columns = React.useMemo(() => [
        {
            Header: "#",
            Cell: ({ cell }) => (
                <div className="flex items-center space-x-4">
                    <p>{cell.row.index + 1}</p>
                </div>
            ),
        },
        {
            Header: "Name",
            accessor: 'name',
            Cell: AvatarCell,
            imgAccessor: "imgUrl",
            emailAccessor: "phoneNumber",
        },
        {
            Header: "Birthday",
            accessor: 'birthday',
            Cell: ({ cell }) => (
                <div className="text-sm text-gray-500">
                    {cell.row.original.birthday ? moment(cell.row.original.birthday, 'YYYY-MM-DD').format('DD MMMM') : 'Not set'}
                </div>
            ),
        },
        {
            Header: "Phone Number",
            accessor: 'phoneNumber',
            Cell: ({ cell }) => (
                <div className="text-sm text-gray-500">
                    {cell.row.original.phoneNumber ? cell.row.original.phoneNumber : 'Not set'}
                </div>
            ),
        },
        // {
        //     Header: "Status",
        //     accessor: 'status',
        //     Cell: StatusPill,
        // },
        {
            Header: "Action",
            accessor: 'id',
            idAccessor: 'id',
            Cell: ({ cell, row, column }) => (
                <div className="flex items-center space-x-1">
                    <button
                        className="px-3 py-1 uppercase leading-wide font-bold text-xs rounded-full shadow-sm bg-yellow-100 text-yellow-800"
                        onClick={() => handleEdit(cell.row.original)}
                    >
                        Edit
                    </button>
                    <button
                        className="px-3 py-1 uppercase leading-wide font-bold text-xs rounded-full shadow-sm bg-red-100 text-red-800"
                        onClick={() => handleDeleteMember(row.original)}
                    >
                        <TrashIcon className="h-5 w-5" />
                    </button>
                </div>
            ),
        }
    ], [])

    if (!user || !user.id) {
        navigate('/login');
        return;
    }

    const handleAddMember = () => {
        console.log("Add guest");
        setShowModal(true);
    }

    const handleEdit = (data) => {
        setFormData(data);
        setEdit(true);
        setShowModal(true);
        console.log("Edit guest");
        console.log(data);
    };


    const handleCloseModal = (e) => {
        e.preventDefault();
        setFormData({});
        setShowModal(false);
    };

    const handleEditMember = (e) => {
        e.preventDefault();
        console.log("Edit Cell guest");
        console.log(formData);
        updateGuest({ cellId: id, id: formData.id, data: formData })
        setFormData({});
        setShowModal(false);
        setEdit(false);
    };

    const handleDeleteMember = async (guest) => {
        const ok = await confirmDelete(confirm, {
            what: 'guest', name: guest.name,
            consequence: 'They will no longer appear on new reports. Past reports keep their attendance.',
        });
        if (!ok) return;
        deleteGuest({ cellId: id, id: guest.id })
        setShowModal(false);
    };

    const handleSaveMember = (e) => {
        e.preventDefault();
        console.log("Save guest");
        console.log(formData);
        // setGuests(null);
        addGuest({ cellId: id, data: formData });
        // setFormData({});
        setShowModal(false);
    };

    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setFormData(values => ({ ...values, [name]: value }))
    }

    const totalGuests = guests.length;
    const birthdayMonthGuests = guests.filter((guest) => {
        if (!guest?.birthday) {
            return false;
        }
        return moment(guest.birthday, 'YYYY-MM-DD').month() === moment().month();
    }).length;

    return (
        <div className="min-h-screen bg-gray-100 text-gray-900">

            <Modal
                title={edit ? "Edit guest" : "Add guest"}
                description={edit ? undefined : "You can also add first-time guests while recording a report."}
                size="sm"
                submitLabel={edit ? "Save changes" : "Add guest"}
                onClose={handleCloseModal}
                show={showModal}
                onSubmit={edit ? handleEditMember : handleSaveMember}
            >
                <form className='space-y-6'>
                    <div>
                        <label htmlFor="name" className="block text-sm font-medium leading-6 text-gray-900">Full Name</label>
                        <div className="mt-2">
                            <input
                                id="name"
                                name="name"
                                type="text"
                                autoComplete="full name"
                                required
                                className="px-3 py-2 block w-full rounded-md border-0 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-emerald-600 sm:text-sm sm:leading-6"
                                value={formData?.name || ""}
                                onChange={handleChange}
                            />
                        </div>
                    </div>
                    <div>
                        <label htmlFor="phoneNumber" className="block text-sm font-medium leading-6 text-gray-900">Phone number</label>
                        <div className="mt-2">
                            <input
                                id="phoneNumber"
                                name="phoneNumber"
                                type="text"
                                autoComplete="phone number"
                                required
                                className="px-3 py-2 block w-full rounded-md border-0 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-emerald-600 sm:text-sm sm:leading-6"
                                value={formData?.phoneNumber || ""}
                                onChange={handleChange}
                            />
                        </div>
                    </div>
                    <div>
                        <label htmlFor="dob" className="block text-sm font-medium leading-6 text-gray-900">Date of birth</label>
                        <div className="mt-2">
                            <input
                                id="dob"
                                name="birthday"
                                type="date"
                                autoComplete="date of birth"
                                required
                                className="px-3 py-2 block w-full rounded-md border-0 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-emerald-600 sm:text-sm sm:leading-6"
                                value={formData?.birthday || ""}
                                onChange={handleChange}
                            />
                        </div>
                    </div>
                </form>
            </Modal>
            <main className="max-w-full mx-auto px-4 sm:px-6 lg:px-8 py-6">
                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-8">
                    <div>
                        <h1 className="text-3xl font-bold text-gray-900">Guests</h1>
                        <p className="text-gray-500 mt-1">Track and manage guests in your cell.</p>
                    </div>
                    {id && (
                        <button
                            onClick={handleAddMember}
                            className="flex flex-row items-center gap-2 bg-emerald-500 text-white hover:bg-emerald-600 active:bg-emerald-700 font-semibold px-4 py-2 rounded-lg shadow-md transition-all duration-150"
                            type="button"
                        >
                            <PlusCircleIcon className="h-5 w-5" />
                            Add Guest
                        </button>
                    )}
                </div>

                {id === undefined ? (
                    <div className="bg-white shadow-lg rounded-lg p-8 flex flex-col items-center justify-center">
                        <UserGroupIcon className="h-16 w-16 text-gray-300 mb-4" />
                        <h2 className="text-xl font-semibold text-gray-700">No assigned cell</h2>
                        <p className="text-gray-500 mt-1">This account is not assigned to a cell yet. Please contact an admin.</p>
                    </div>
                ) : (
                    <>
                        {guests.length > 0 && (
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                                <StatCard title="Total Guests" value={totalGuests} icon={<UserGroupIcon className="h-6 w-6 text-white" />} bgColor="bg-emerald-500" />
                                <StatCard title="Birthdays This Month" value={birthdayMonthGuests} icon={<UserAddIcon className="h-6 w-6 text-white" />} bgColor="bg-blue-500" />
                            </div>
                        )}

                        <div className="bg-white shadow-lg rounded-lg overflow-hidden">
                            {guests.length > 0 ? (
                                <div className="overflow-x-auto">
                                    <Table columns={columns} data={guests} resetKey={id} />
                                </div>
                            ) : (
                                <div className="flex flex-col items-center justify-center py-16 px-6 text-center">
                                    <UserGroupIcon className="h-16 w-16 text-gray-300 mb-4" />
                                    <h2 className="text-xl font-semibold text-gray-700">No guests found</h2>
                                    <p className="text-gray-500 mt-1">Add your first guest to start tracking attendance and follow-up.</p>
                                    <button
                                        onClick={handleAddMember}
                                        className="mt-4 flex items-center gap-2 bg-emerald-500 text-white hover:bg-emerald-600 font-medium px-4 py-2 rounded-lg transition-colors"
                                        type="button"
                                    >
                                        <PlusCircleIcon className="h-5 w-5" />
                                        Add First Guest
                                    </button>
                                </div>
                            )}
                        </div>
                    </>
                )}
            </main>
        </div>
    );
}

const StatCard = ({ title, value, icon, bgColor }) => (
    <div className="bg-white shadow-lg rounded-lg p-6">
        <div className="flex items-center justify-between">
            <div>
                <p className="text-gray-600 text-sm font-medium mb-1">{title}</p>
                <p className="text-3xl font-bold text-gray-900">{value}</p>
            </div>
            <div className={`${bgColor} rounded-full p-3`}>{icon}</div>
        </div>
    </div>
);

Guests.propTypes = {
    guests: PropTypes.array.isRequired,
    user: PropTypes.object.isRequired,
    guestsGetRequested: PropTypes.bool.isRequired,
    getGuestsRequested: PropTypes.func.isRequired,
    addGuestRequested: PropTypes.func.isRequired,
    updateGuestRequested: PropTypes.func.isRequired,
    deleteGuestRequested: PropTypes.func.isRequired,
};

Guests.defaultProps = {
    guests: [],
    user: {},
    guestsGetRequested: false,
};

const mapStateToProps = (state) => ({
    guests: state.guest.guests,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getGuestsRequested,
    addGuestRequested,
    updateGuestRequested,
    deleteGuestRequested,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Guests);
